import React from "react";
import { Card, Container, Row, Col } from "react-bootstrap";

const Services = () => {
  const services = [
    {
      icon: (
        <img
          src="/assets/phone-call.svg"
          alt="Call Answering"
          className="img-fluid"
        />
      ),
      title: "Call Answering",
      description:
        "24/7 live receptionists managing your inbound calls professionally",
    },
    {
      icon: (
        <img
          src="/assets/message-circle.svg"
          alt="Live Chat Support"
          className="img-fluid"
        />
      ),
      title: "Live Chat Support",
      description: "Real-time website chat to engage and assist your visitors",
    },
    {
      icon: (
        <img
          src="/assets/calendar.svg"
          alt="Appointment Scheduling"
          className="img-fluid"
        />
      ),
      title: "Appointment Scheduling",
      description: "Efficient management of client bookings and calendar",
    },
    {
      icon: (
        <img
          src="/assets/filter.svg"
          alt="Lead Screening"
          className="img-fluid"
        />
      ),
      title: "Lead Screening",
      description: "Qualifying potential clients based on your criteria",
    },
    {
      icon: (
        <img
          src="/assets/credit-card.svg"
          alt="Payment Collection"
          className="img-fluid"
        />
      ),
      title: "Payment Collection",
      description: "Secure and seamless payment processing",
    },
    {
      icon: (
        <img
          src="/assets/pie-chart.svg"
          alt="Analytics & Reports"
          className="img-fluid"
        />
      ),
      title: "Analytics & Reports",
      description: "Detailed insights into your communication metrics",
    },
  ];

  return (
    <Container className="py-5 body-font">
      <h1 className="text-center fs-four-title anybody-font fw-bold my-4">
        Nouraa’s Services
      </h1>
      <p className="text-center fs-two gray-color mb-4">
        Comprehensive solutions for your business communication needs
      </p>
      <Row>
        {services.map((service, index) => (
          <Col md={4} className="my-4" key={index}>
            <Card className="h-100 text-center border-light-subtle shadow-sm p-4 rounded-3">
              <Card.Body>
                <div className="mb-3 services-icon-container">
                  {service.icon}
                </div>
                <Card.Title>{service.title}</Card.Title>
                <Card.Text>{service.description}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Services;
